// extracted by mini-css-extract-plugin
export default {"container":"jPKSAdFKKFRo42ZXbw1O"};